import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearMappingBackUrl} from "../config/crystalclear-mapping-back-url";
import {SrcMappingAccountCode} from "../../model/mapping/src-mapping-account-code";

@Injectable({
  providedIn: 'root'
})
export class MappingSrcMappingAccountCodeService extends CommonCrudService<SrcMappingAccountCode> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearMappingBackUrl.GET_MAPPING_SRCMAPPINGACCOUNTCODE_LIST,
      CrystalclearMappingBackUrl.SAVE_MAPPING_SRCMAPPINGACCOUNTCODE,
      CrystalclearMappingBackUrl.DELETE_MAPPING_SRCMAPPINGACCOUNTCODE);
  }

}
